import { ModalRef } from '@msdk/common'
import { Entity, StringValue } from '@msdk/definitions'
import { useState } from 'react'
import { Wizard } from 'react-use-wizard'

import { AddSignInMethodPopup } from './AddSignInMethodPopup'
import { ChooseSignInMethodPopup } from './ChooseSignInMethodPopup'
import { CodeProvider } from './CodeContext'
import { FaceGeneratedCodePopup } from './FaceGeneratedCodePopup'
import { NFCGeneratedCodePopup } from './NFCGeneratedCodePopup'
import { NicknamePopup } from './NicknamePopup'
import { PasswordPopup } from './PasswordPopup'
import { PrivacyNoticePopup } from './PrivacyNoticePopup'
import { SetupFaceRecoPopup } from './SetUpFaceRecoPopup'
import { StyledDialog } from './shared'
import { UploadPhotoPopup } from './UploadPhotoPopup'

interface Props {
  modalRef?: ModalRef
  startIndex?: number
}

export function UserAuthenticationNGID({ modalRef, startIndex = 0 }: Props) {
  const [nickname, setNickname] = useState<StringValue | null>(null)
  const [isNicknameUnique, setIsNicknameUnique] = useState<boolean | null>(null)
  const [uploadedPhoto, setUploadedPhoto] = useState<Entity | undefined>(undefined)
  const [customWidth, setCustomWidth] = useState<number | undefined>(undefined)
  return (
    <StyledDialog open={modalRef?.status === 'Open'} onClose={() => modalRef?.close()} $width={customWidth}>
      <CodeProvider>
        <Wizard startIndex={startIndex}>
          {/* 0 */}
          <ChooseSignInMethodPopup modalRef={modalRef} />
          {/* 1 */}
          <NicknamePopup
            modalRef={modalRef}
            nickname={nickname}
            onNicknameChange={setNickname}
            isUnique={isNicknameUnique}
            onUniqueChange={setIsNicknameUnique}
          />
          {/* 2 */}
          <PasswordPopup modalRef={modalRef} nickname={nickname} />
          {/* 3 */}
          <AddSignInMethodPopup
            modalRef={modalRef}
            uploadedPhoto={uploadedPhoto}
            onUploadedPhotoChange={setUploadedPhoto}
          />
          {/* 4 */}
          <PrivacyNoticePopup modalRef={modalRef} onSetCustomWidth={setCustomWidth} />
          {/* 5 */}
          <SetupFaceRecoPopup modalRef={modalRef} />
          {/* 6 */}
          <UploadPhotoPopup modalRef={modalRef} uploadedPhoto={uploadedPhoto} />
          {/* 7 */}
          <FaceGeneratedCodePopup modalRef={modalRef} />
          {/* 8 */}
          <NFCGeneratedCodePopup modalRef={modalRef} />
        </Wizard>
      </CodeProvider>
    </StyledDialog>
  )
}
